import { render, staticRenderFns } from "./SidebarCategory.vue?vue&type=template&id=1ed7ba1b&"
import script from "./SidebarCategory.vue?vue&type=script&lang=js&"
export * from "./SidebarCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports